import React from "react";

const ReadOnlyRow = ({ contact, handleEditClick , handleDeleteClick }) => {
  return (
    <tr>
      <td>{contact.Date}</td>
      <td className="text-center">{contact.description}</td>
      <td>                                                        
          <button type="button" className="btn btn-sm btn-toggle" data-toggle="button" aria-pressed="false" style={{marginLeft:"110px"}} autocomplete="off" id="toggBtn_1" ><div className="handle"></div></button>
        </td>
     
      <td className="text-center">
        <button className="btn btn-sm btn-transparent " style={{marginLeft:"30px", marginTop:"-15px"}}
          type="button"
          onClick={(event) => handleEditClick(event, contact)}
        >
         <i className='bi bi-pencil'></i>
        </button>
        <button className="btn btn-sm btn-transparent "  style={{ marginLeft:"-20px", marginTop:"-15px"}}
        type="button" onClick={() => handleDeleteClick(contact.id)}>
       <i className='bi bi-trash'></i>
        </button>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;